import React, {HTMLAttributes} from 'react';
import clsx from 'clsx'


import './AppFrameStyles.scss'


export const AppFrame = (props: HTMLAttributes<HTMLDivElement>) => {
    const {
        children, className, ...rest
    } = props

    return (
        <div className={clsx('app-frame', className)} {...rest}>
            {children}
        </div>
    );
}
